import { render, staticRenderFns } from "./RatingAdvancedPage.vue?vue&type=template&id=8a031154&scoped=true"
import script from "./RatingAdvancedPage.vue?vue&type=script&lang=js"
export * from "./RatingAdvancedPage.vue?vue&type=script&lang=js"
import style0 from "./RatingAdvancedPage.vue?vue&type=style&index=0&id=8a031154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a031154",
  null
  
)

export default component.exports